<template>
  <v-card
                :loading="showDialogProgress"
                :disabled="showDialogProgress"
              >
  <div class="IORequest">
    <box class="" :title="this.$t('nav-request-io')">
      <div class="px-3 pt-2">
        <v-form ref="form" v-model="form">
          <v-row>
            <v-col cols="12" sm="6">
              <v-row>
                <v-col class="max-width-text-title px-1 d-flex">
                  <label class="my-auto">{{ $t("date") }} : </label>
                </v-col>
                <v-col>
                  <dialog-date-picker
                    :label="$t('date') + ':'"
                    :initDate="initBeginDate"
                    @dateResult="bDate"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="6">
              <v-row class="mt-2 mt-sm-0">
                <v-col class="max-width-text-title px-1 d-flex">
                  <label class="my-auto">{{ $t("time") }} : </label>
                </v-col>
                <v-col>
                  <dialog-time-picker
                    :label="$t('time') + ':'"
                    :initTime="initBeginTime"
                    @dateResult="bTime"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col cols="12" sm="6">
              <v-row>
                <v-col class="max-width-text-title px-1 d-flex">
                  <label class="my-auto">{{ $t("type") }} : </label>
                </v-col>
                <v-col>
                  <v-radio-group
                    v-model="ioParams.IoKind"
                    row
                    dense
                    class="ma-0"
                    hide-details=""
                  >
                    <v-radio
                      :label="$t('enter')"
                      value="1"
                      class="mx-0"
                    ></v-radio>
                    <v-radio :label="$t('exit')" value="2"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row class="mt-2" v-if="clockVisible">
            <v-col cols="12" sm="6">
              <v-row>
                <v-col class="max-width-text-title px-1 d-flex">
                  <label class="my-auto">دستگاه ساعت: </label>
                </v-col>
                <v-col>
                  <v-select
                    solo
                    :items="clockList"
                    v-model="selectedClock"
                    hide-details=""
                    
                  >
                    <template v-slot:prepend-item>
                      <div class="px-2">
                        <v-row>
                          <v-col><strong>نام ساعت</strong> </v-col>
                          <v-col><strong>شماره دستگاه</strong> </v-col>
                        </v-row>
                      </div>
                      <v-divider class="mt-1"></v-divider>
                    </template>
                    <template slot="item" slot-scope="data">
                      <v-row>
                        <v-col>{{ data.item.Name }}</v-col>
                        <v-col>{{ data.item.MachineNo }}</v-col>
                      </v-row>
                    </template>
                    <template slot="selection" slot-scope="data">
                      {{ data.item.Name }}
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col cols="12" sm="12">
              <v-row>
                <v-col class="max-width-text-title px-1 d-flex">
                  <label class="my-auto">{{ $t("description") }} : </label>
                </v-col>
                <v-col>
                  <v-textarea
                    solo
                    dense
                    hide-details=""
                    ref="description"
                    v-model="ioParams.Description"
                    auto-grow
                    :placeholder="$t('description')"
                    rows="2"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>

        <v-card-actions class="px-0 pt-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="showWorkCalndar = !showWorkCalndar">{{
            $t("workCalendar")
          }}</v-btn>
          <v-btn color="primary" @click="showIntervalIOList">{{
            $t("nav-interval-io")
          }}</v-btn>
          <v-btn
            color="primary"
            :disabled="!form"
            :loading="isLoading"
            @click="addIO"
            >{{ $t("submit") }}</v-btn
          >
        </v-card-actions>
      </div>
    </box>

    <IntervalIOList
      ref="intervalIOList"
      class="py-2"
      :visible="IntervalIOListVisibility"
    />
    <WorkCalendar :showWorkCalndar="showWorkCalndar" :perno="this.perno" />
  </div>
  </v-card>
</template>

<script>
import IntervalIOList from "../../components/io/IntervalIO/IntervalIOList.vue";
import WorkCalendar from "../../components/request/WorkCalendar.vue";
import DialogDatePicker from "../../components/widget/DialogDatePicker.vue";
import DialogTimePicker from "../../components/widget/DialogTimePicker.vue";
import EosToastType from "../../model/EosToastType";
import ResultType from "../../model/ResultType";
import TextUtils from "../../utils/TextUtils";
import PageKind from '../../model/PageKind'

export default {
  components: {
    WorkCalendar,
    DialogDatePicker,
    DialogTimePicker,
    IntervalIOList,
  },
  mounted() {
    this.pageLoad();
    this.checkDescriptionRules();
    this.getArgs();
  },
  data() {
    return {
      args: {},
      ioParams: {
        IoKind: "1",
      },
      showWorkCalndar: false,
      form: false,
      isLoading: false,
      initBeginDate: null,
      showDialogProgress: false,
      beginDate: "",
      beginTime: "",
      initBeginTime: "",
      IntervalIOListVisibility: false,
      perno: "",
      clockVisible: false,
      clockList: [],
      selectedClock: "",
    };
  },
  methods: {
    pageLoad() {
      this.loadClock();
    },
    async loadClock() {
      await this.$store.dispatch("getClockSelection").then((result) => {
        if (result.type === ResultType.success) {
          this.clockVisible = result.data;
          
        }
      });

      if (this.clockVisible) {
        this.$store.dispatch("getClocksList").then((result) => {
          console.log(result);
          if (result.type === ResultType.success) {
            this.clockList = result.data;
            if (this.clockList.length > 0) {
              if (this.details) {
                var selected = this.clockList.find(
                  (item) => item.Code == this.details.Code
                );
                if (selected) {
                  this.selectedClock = selected;
                }
              } else {
                this.selectedClock = this.clockList[0];
              }
            }
          }
        });
      }
    
    },
    getArgs() {
      this.args = this.$route.params.details;
      if (this.args) {
        this.loadRegistration(this.args);
      }

      if (this.args && this.args.selectedPerno) {
        this.perno = this.args.selectedPerno;
      }
debugger
      var selectedDate = this.$route.query.SD;
      if (selectedDate) {
        this.initBeginDate = this.beginDate = selectedDate;
      }
    },
    loadRegistration(args) {
      const params = new URLSearchParams();
      params.append("id", TextUtils.convertToEnglishDigits(args.PageNo));
      //params.append("dbkind", args.DBKind);
      params.append("year", args.Year);
      params.append("perno", args.selectedPerno || "");
      this.$store.dispatch("GetIoDetail", { params }).then((result) => {
        if (result.type == "success") {
          if (result.data.length > 0) {
            this.details = result.data[0];
            this.details.Year = args.Year;
            this.ShowIODetailForEdit(this.details);
          }
        }
      });
    },
    ShowIODetailForEdit(details) {
      this.ioParams.PageNo = details.Id.toString().trim();
      this.ioParams.Description = details.UserDescription;
      this.ioParams.IoKind = details.Io_Type;
debugger
      this.initBeginDate = this.beginDate = details.ClockDate;
      this.initBeginTime = this.beginTime = details.ClockTime;

      this.loadClock();
    },
    bDate(date) {
      this.beginDate = date;
    },
    bTime(date) {
      this.beginTime = date;
    },
    addIO() {
      this.addIOWithoutLocation();
    },
    
    addIOWithoutLocation() {
      this.showDialogProgress = true;
      if (!this.ioParams.IoKind) {
        this.showDialogProgress = false;
        return;
      }
      debugger;
      const params = new URLSearchParams();
      params.append("InDate", this.beginDate);
      params.append("InTime", this.beginTime);
      if (this.clockVisible) {

        if (this.selectedClock.Code=="" || this.selectedClock.Code==undefined){
          this.$EosToast.show({
            type: EosToastType.error,
            msg:  "لطفا دستگاه ساعت خود را انتخاب کنید",
          });
          this.showDialogProgress = false;
          return;
        }
        else{
          params.append(
          "ClockValue",
          `${this.selectedClock.Code},${this.selectedClock.MachineNo}`
        );

        }
        
      }

      params.append("Description", this.ioParams.Description || "");
      params.append("IoKind", this.ioParams.IoKind);
      params.append("Id", this.ioParams.PageNo || ""); //pageNo
      if (this.args?.selectedPerno) {
        params.append("perno", this.args.selectedPerno);
      }

      this.$store.dispatch("AddIO", { params }).then((result) => {
        if (result.type === "success") {
          this.$EosToast.show({
            type: EosToastType.success,
            msg: this.$t("msg-registration-success", {
              opName: this.$t("nav-request-io"),
            }),
          });

          this.$refs.form.reset();

          //ارسال نوتیفیکیشن به مدیر
          this.SendNotificationForManager(params)

          if (this.ioParams.PageNo && this.args && this.args.from) {
            this.$router.push({ name: this.args.from });
          }
          this.showDialogProgress = false;
        } else {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: result.error || "error",
          });
          this.showDialogProgress = false;
        }
      });
    },
    SendNotificationForManager(params){
      this.$store.dispatch('SendNotificationForManager',{params:{
        personelPerno: params.perno,
            code: -1,//کد مرخصی یا ماموریت - برای اضافه کار و ورود و خروج مقدار -1
            RequestType: PageKind.PageKindType.IO,
            date: params.InDate,
            time: params.InTime,
      }})
    },
    checkDescriptionRules() {
      var IsCommentRequired =
        this.$store.state.settings.settings.IsCommentRequiredForIo;
      if (IsCommentRequired == 1) {
        this.$refs.description.rules = [this.$rules.required];
      }
    },
    showIntervalIOList() {
      if (this.IntervalIOListVisibility == false) {
        this.$refs.intervalIOList.showIntervalDays(2, this.beginDate);
      }
      this.IntervalIOListVisibility = !this.IntervalIOListVisibility;
    },
  },
};
</script>

<style scoped>
.max-width-text-title {
  max-width: 100px;
}
.clock-header {
  background: #f2f2f2;
}
</style>